import { combineReducers } from 'redux';

import loadSitesWithAliasesError from './loadSitesWithAliasesError';
import loadActiveSitesError from './loadActiveSitesError';
import loadSiteError from './loadSiteError';
import switchSiteStatusError from './switchSiteStatusError';
import deleteSiteError from './deleteSiteError';


export default combineReducers({
  loadSitesWithAliasesError,
  loadActiveSitesError,
  loadSiteError,
  switchSiteStatusError,
  deleteSiteError,
});
